/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';

import { Container, Grid, Typography } from '@material-ui/core';
import { AddRounded } from "@material-ui/icons";

import { PrimaryButtonRounded } from "../../../elements/PrimaryButtonRounded";
import CustomIcons from "../../../icons/CustomIcons";
import CreateApp from "../../app/CreateApp";

import { useStyles } from "./styles";

export function AppLandingContent() {
    const classes = useStyles();
    const intl = useIntl();
    const [isNewAppWizardOpen, setNewAppWizardOpen] = useState(false);

    const openNewAppWizard = () => {
        setNewAppWizardOpen(true);
    };

    const closeNewAppWizard = () => {
        setNewAppWizardOpen(false);
    };

    const createButtonLabel = intl.formatMessage({
        id: 'application.home.landingPage.createButton.label',
        defaultMessage: 'Create'
    });

    const CreateBtn = () => {
        return (
            <PrimaryButtonRounded className={classes.createBtn}
                dataTestId="create-application-btn"
                onClick={openNewAppWizard}
                startIcon={<AddRounded />}
                text={createButtonLabel}
            />
        );
    };

    return (
        <React.Fragment>
            <Grid container={true} justifyContent="center" direction="row" alignItems="center">
                <Grid item={true} xs={12}>
                    <Container fixed={true}>
                        <div className={classes.imgContainer}>
                            <CustomIcons icon='create-with-choreo' />
                        </div>
                        <div className={classes.primaryTitleContainer}>
                            <Typography
                                component="div"
                                className={classes.primaryTitle}
                                gutterBottom={true}
                            >
                                <FormattedMessage
                                    id='application.home.landingPage.title'
                                    defaultMessage='Time to create your first application'
                                />
                            </Typography>
                        </div>
                        <Typography variant="subtitle1" component="div" className={classes.secondaryTitle}>
                            <FormattedMessage
                                id='application.home.landingPage.subTitle'
                                defaultMessage='You don&apos;t have any applications'
                            />
                        </Typography>
                        <CreateBtn />
                    </Container>
                </Grid>
            </Grid>
            <CreateApp open={isNewAppWizardOpen} onClose={closeNewAppWizard} isEdit={false} redirectToApplication={true} />
        </React.Fragment>
    );
}

export default AppLandingContent;
